import { Box } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { SidebarProvider } from '../context/SidebarContext';
import Breadcrumbs from '../globalComponents/BreadCrumbs';
import Header from './Header';
import Sidebar from './Sidebar';

type Props = {
  children?: React.ReactNode;
  plantId?: any;
  style?: any;
  factoryResetContainer?: boolean;
};

export default function LayoutComponent(props: Props) {

  return (
    <SidebarProvider>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          ...props.style,
        }}
      >
        <Header plantId={props.plantId} />
        <Sidebar />
        <Box
          component="main"
          sx={{
            overflowY: 'auto',
            height: 'calc(100% - 64px)',
            mt: '64px',
            py: {
              xs: 2,
              md: 3,
            },
            px: {
              xs: 2,
              extraXs: 2,
              md: 7,
            },
            boxSizing: 'border-box'
          }}
        >
          <Breadcrumbs />
            <Outlet />
        </Box>
      </Box>
    </SidebarProvider>
  );
}
